import request, { deAxios } from '@/utils/request'
import { User } from '@/types'

const apiFactory = () => {
  const getAssignees = (): Promise<User.API.ReqRes.UserContacts.Assignee[]> => {
    return request({
      url: 'cadence-service/assignees/me',
      method: 'get'
    })
      .then(deAxios)
  }
  const getEducationTeam = (): Promise<User.API.ReqRes.UserContacts.EducationTeam> => {
    return request({
      url: 'cadence-service/public/education-team-info',
      method: 'get'
    })
      .then(deAxios)
  }
  return { getAssignees, getEducationTeam }
}

export default apiFactory
